import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ 
    name: 'linebreaks', 
    standalone: true 
})

export class LinebreaksPipe implements PipeTransform {
  
    transform(value: string): string {
    if (!value) return '';
    const escaped = value.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return escaped.replace(/\n/g, '<br>');
  }
}
